/**
 * Vuex Store for Snap Polls Admin Portal
 * Central state management for the application
 */

import { createStore } from "vuex";

export default createStore({
  state: {
    GetCurrentUser: [],
    GetScratchPadText: "",
  },

  getters: {
    get_current_user_details: (state) => {
      return state.GetCurrentUser;
    },
    get_scratch_pad_text: (state) => {
      return state.GetScratchPadText;
    },
  },

  mutations: {
    SET_CURRENTUSER_DETAILS(state, GetCurrentUserDetails) {
      state.GetCurrentUser = GetCurrentUserDetails;
    },
    SET_SCRATCHPAD_TEXT(state, ScratchPadText) {
      state.GetScratchPadText = ScratchPadText;
    },
  },

  actions: {},
});
